export const items = [
  {
    optionTitle: "Konu Başlığı",
    labelDesc: "Konu Başlığı",
    optionItems: [
      {
        title: "E-Ticaret",
        color: "#66D158",
      },
      {
        title: "Ürün & Marka",
        color: "#FF9F0A",
      },
      {
        title: "Sosyal Medya",
        color: "#0A84FF",
      },
      {
        title: "Reklamlar",
        color: "#FF375F",
      },
      {
        title: "Blog Yazımı",
        color: "#AC8E68",
      },
      {
        title: "Satış & Pazarlama",
        color: "#FFD60A",
      },

      {
        title: "E-Mail",
        color: "#64D2FF",
      },

      {
        title: "SEO",
        color: "#BF5AF2",
      },
    ],
  },
  {
    optionTitle: "Konu Başlığı",
    labelDesc: "Dil Seçimi",
    optionItems: [
      {
        title: "E-Ticaret",
        color: "#66D158",
      },
      {
        title: "Ürün & Marka",
        color: "#FF9F0A",
      },
      {
        title: "Sosyal Medya",
        color: "#0A84FF",
      },
      {
        title: "Reklamlar",
        color: "#FF375F",
      },
      {
        title: "Blog Yazımı",
        color: "#AC8E68",
      },
      {
        title: "Satış & Pazarlama",
        color: "#FFD60A",
      },

      {
        title: "E-Mail",
        color: "#64D2FF",
      },

      {
        title: "SEO",
        color: "#BF5AF2",
      },
    ],
  },
  {
    optionTitle: "Konu Başlığı",
    labelDesc: "Alt Başlık",
    optionItems: [
      {
        title: "E-Ticaret",
        color: "#66D158",
      },
      {
        title: "Ürün & Marka",
        color: "#FF9F0A",
      },
      {
        title: "Sosyal Medya",
        color: "#0A84FF",
      },
      {
        title: "Reklamlar",
        color: "#FF375F",
      },
      {
        title: "Blog Yazımı",
        color: "#AC8E68",
      },
      {
        title: "Satış & Pazarlama",
        color: "#FFD60A",
      },

      {
        title: "E-Mail",
        color: "#64D2FF",
      },

      {
        title: "SEO",
        color: "#BF5AF2",
      },
    ],
  },
  {
    optionTitle: "Konu Başlığı",
    labelDesc: "Dil Tonu",
    optionItems: [
      {
        title: "E-Ticaret",
        color: "#66D158",
      },
      {
        title: "Ürün & Marka",
        color: "#FF9F0A",
      },
      {
        title: "Sosyal Medya",
        color: "#0A84FF",
      },
      {
        title: "Reklamlar",
        color: "#FF375F",
      },
      {
        title: "Blog Yazımı",
        color: "#AC8E68",
      },
      {
        title: "Satış & Pazarlama",
        color: "#FFD60A",
      },

      {
        title: "E-Mail",
        color: "#64D2FF",
      },

      {
        title: "SEO",
        color: "#BF5AF2",
      },
    ],
  },
];
